import axios from "axios";
import { anoucemente } from "./models";
import routersName from "./routernames";
const api = new routersName().annoucementListClient;

export default class AnaucemenClient {
  getItemsByPage = async () => {
    try {
      const response = await axios.get(`${api}/all`);
      return response.data.data as anoucemente[];
    } catch (error) {
      throw new Error("Could not get taxis");
    }
  };
  getItem = async (uid:any) => {
    try {
      const response = await axios.get(`${api}/item/${uid}`);
      return response.data.data[0];
    } catch (error) {
      throw new Error("Could not get taxis");
    }
  };

  
}
